const userManagementPageRolesSectionCopy = {
  errorMessageUpdateRolesFailed:
    'Sorry, an unexpected error occured while trying to update your user roles. Please try again.',
  rightMenuItemLabel: 'Update User',
  sectionTitle: 'Users',
  successMessageRolesUpdated: 'Your roles have been updated.'
};

export default userManagementPageRolesSectionCopy;
